import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';


@Component({
    selector: 'formly-object-type',
    template: `
        <div class="mb-3 {{to.className}}">
          @if (to.label) {
            <legend class="text-xl text-primary mb-2">{{ to.label }}</legend>
          }
          @if (to.description) {
            <p>{{ to.description }}</p>
          }
          @if (showError && formControl.errors) {
            <div class="alert alert-danger" role="alert">
              <formly-validation-message [field]="field"></formly-validation-message>
            </div>
          }
          <div class="{{to.fieldGroupClassName}}">
            @for (f of field.fieldGroup; track f) {
              <formly-field [field]="f"></formly-field>
            }
          </div>
        </div>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormlyModule]
})
export class ObjectTypeComponent extends FieldType {
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license */
